<script setup>
import { computed } from 'vue';
import { usePlanStore } from '../../../../store/planStore';

const props = defineProps({
    plans: {
        type: Array,
        default: () => [],
    },
    index: {
        type: Number,
        default: 0,
    },
});

const planStore = usePlanStore();

const plansByPlanType = computed(() => {
    if (planStore.plan_type === 'day') {
        return props.plans.filter(plan => plan.package_type === 'day');
    }

    if (planStore.plan_type === 'month') {
        return props.plans.filter(plan => plan.package_type === 'month');
    }
});

function handlePlan(plan) {
    planStore.setPlanByIndex({ index: props.index, plan: plan });
}
</script>

<template>
    <div class="purchase-rent-plan__body-plan-types">
        <div v-if="plansByPlanType.length" v-for="plan in plansByPlanType"
            class="purchase-rent-plan__body-plan-type" :class="{ 'active': planStore.plans[index]?.id === plan.id }"
            @click="handlePlan(plan)">
            <div class="flex justify-between">
                <div class="purchase-rent-plan__body-plan-type-info">{{ plan.name }}</div>
                <div v-if="plan.note" class="purchase-rent-plan__body-plan-type-note">
                    <div class="purchase-rent-plan__body-plan-type-note__item" v-html="plan.note"></div>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"
                        fill="#7DD3FC">
                        <path
                            d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
                    </svg>
                </div>
            </div>
            <div v-if="plan.description" class="purchase-rent-plan__body-plan-type-des" v-html="plan.description"></div>
            <div class="purchase-rent-plan__body-plan-type-price">
                ${{ plan.price }} Per {{ planStore.plan_type === 'month' ? 'month' : 'day' }}
            </div>
        </div>
        <div v-if="!plans.length" class="font-light">
            {{ $t("purchase-rent-page.plans.selectDestinationFirst") }}
        </div>
    </div>
</template>